import React, { useEffect, useState } from "react";
import { IoMdSend } from "react-icons/io";
import LoadingPage from "../Loading/loading";
import {
  changeBulkAdmin,
  getAdmins,
  getTeamOfAdmin,
  removeFromListOfUsers,
} from "../../api/admins";
import { useParams } from "react-router-dom";
import { Cookies } from "react-cookie";

const TeamPage = () => {
  const cookie = new Cookies();
  const params = useParams();
  const [admins, setAdmins] = useState(null);
  const [searchTerm, setSearchTerm] = useState("");
  const [users, setUsers] = useState(null);
  const [ids, setIds] = useState([]);
  const [totalPages, setPages] = useState([]);
  const [totalUsers, setTotalUsers] = useState(0);
  const [currentPage, setCurrentPage] = useState(cookie.get("pageTeam") || 1);

  useEffect(() => {
    setUsers(null);
    getTeamOfAdmin(params.id, currentPage, searchTerm).then((result) => {
      setUsers(result.data.response);
      setTotalUsers(result.data.total);
      setPages(result.data.pages);
    });
    getAdmins().then((result) => {
      setAdmins(result.data.admins);
    });
  }, [currentPage]);

  const toggleSelect = (id) => {
    setIds((prev) => {
      if (prev.includes(id)) {
        return prev.filter((item) => item !== id); // Remove ID if already selected
      } else {
        return [...prev, id]; // Add ID if not selected
      }
    });
  };

  const selectAllUsers = () => {
    setIds([]);
    const allIds = users.map((users) => users._id);
    setIds(allIds);
  };

  const clearAllSelections = () => {
    setIds([]);
  };

  const remove = () => {
    cookie.set("pageTeam", 1);
    setCurrentPage(1);
    removeFromListOfUsers(params.id, ids).then((result) => {
      getTeamOfAdmin(params.id, 1, searchTerm).then((result) => {
        setUsers(result.data.response);
        setPages(result.data.pages);
        setIds([]);
      });
    });
  };

  const changeBulk = (newId) => {
    cookie.set("pageTeam", 1);
    setCurrentPage(1);
    changeBulkAdmin(ids, params.id, newId).then((result) => {
      getTeamOfAdmin(params.id, 1, searchTerm).then((result) => {
        setUsers(result.data.response);
        setPages(result.data.pages);
        setIds([]);
      });
    });
  };

  const handlePageClick = (page) => {
    setCurrentPage(page);
    cookie.set("pageTeam", page);
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  const handleNext = () => {
    if (currentPage < totalPages) {
      setCurrentPage(currentPage + 1);
      cookie.set("pageTeam", currentPage + 1);
      window.scrollTo({
        top: 0,
        behavior: "smooth",
      });
    }
  };

  const renderPageNumbers = () => {
    let pages = [];

    if (totalPages <= 10) {
      // Show all pages if less than 10
      for (let i = 1; i <= totalPages; i++) {
        pages.push(i);
      }
    } else {
      // Always show 1-10
      if (currentPage <= 10) {
        for (let i = 1; i <= 10; i++) {
          pages.push(i);
        }
        pages.push("...");
        pages.push(totalPages);
      } else {
        // After page 10, show current - 2 to current + 2
        pages.push(1);
        pages.push("...");
        let start = Math.max(currentPage - 2, 2);
        let end = Math.min(currentPage + 2, totalPages - 1);

        for (let i = start; i <= end; i++) {
          pages.push(i);
        }

        if (end < totalPages - 1) {
          pages.push("...");
        }
        pages.push(totalPages);
      }
    }

    return pages.map((page, index) =>
      page === "..." ? (
        <span key={index} className="px-2">
          ...
        </span>
      ) : (
        <button
          key={index}
          onClick={() => handlePageClick(page)}
          className={
            currentPage === page ? "paginationButtonActive" : "paginationButton"
          }
        >
          {page}
        </button>
      ),
    );
  };

  const handleSearch = () => {
    setCurrentPage(1);
    setUsers(null);
    getTeamOfAdmin(params.id, 1, searchTerm).then((result) => {
      setUsers(result.data.response);
      setPages(result.data.pages);
    });
  };

  return (
    <>
      {users === null ? (
        <div className="main-content">
          <LoadingPage />{" "}
        </div>
      ) : (
        <div className="main-content">
          <div className="card-cards">
            <div
              className="card-info"
              style={{ justifyContent: "space-between" }}
            >
              <div>
                <input
                  type="checkbox"
                  checked={ids.length === users.length}
                  onChange={() => {
                    if (ids.length !== users.length) {
                      selectAllUsers();
                    } else {
                      clearAllSelections();
                    }
                  }}
                  className="client-checkbox"
                />
                <span className="label">Select all</span>
              </div>

              {ids.length !== 0 && (
                <p className="line">
                  <span className="label">Number of selection:</span>{" "}
                  {ids.length}
                </p>
              )}

              {ids.length !== 0 && (
                <>
                  {admins !== null && (
                    <p className="line">
                      <span className="label">Assign:</span>{" "}
                      <select
                        className="form-select form-control form-select-lg border border-dark"
                        aria-label=".form-select-lg example"
                        name="type2"
                        value={""}
                        onChange={(e) => {
                          changeBulk(e.target.value);
                        }}
                      >
                        <option value="">No Admin</option>
                        {admins?.map((item, index) => (
                          <option key={index} value={item._id}>
                            {item.admin_code}
                          </option>
                        ))}
                      </select>
                    </p>
                  )}
                </>
              )}
              {ids.length !== 0 && (
                <button
                  onClick={() => {
                    remove();
                  }}
                  className="action-btn remove-btn"
                >
                  Remove
                </button>
              )}
            </div>

            <div>Number of users is {totalUsers}</div>

            <div className="search-container">
              <form
                onSubmit={(e) => {
                  e.preventDefault(); // Prevent page reload
                  handleSearch();
                }}
              >
                <div className="search-input-wrapper">
                  <input
                    type="text"
                    placeholder="Name or Phone number"
                    value={searchTerm}
                    onChange={(e) => setSearchTerm(e.target.value)}
                    className="search-input"
                  />
                  <button
                    type="button"
                    onClick={() => {
                      handleSearch();
                    }}
                    className="password-toggle"
                    aria-label="Show password"
                  >
                    <IoMdSend />
                  </button>
                </div>
              </form>
            </div>

            <div
              className="mt-4"
              style={{
                display: "flex",
                justifyContent: "center",
                flexWrap: "wrap",
              }}
            >
              {renderPageNumbers()}
              <button
                onClick={handleNext}
                disabled={currentPage === totalPages}
                className="paginationButton"
              >
                Next
              </button>
            </div>

            {users?.map((user) => (
              <div
                key={user._id}
                className={`card-card ${user.ban ? "banned" : ""}`}
                onClick={() => toggleSelect(user._id)}
              >
                <div className="card-info">
                  <input
                    type="checkbox"
                    checked={ids.includes(user._id)}
                    onChange={() => toggleSelect(user._id)}
                    className="client-checkbox"
                  />
                  <div>
                    <p className="line">
                      <span className="label">Name:</span> {user.name}
                    </p>
                    <p className="line">
                      <span className="label">Phone:</span> {user.phone}
                    </p>
                    <p className="line">
                      <span className="label">Destination:</span> {user.area}
                    </p>
                    <p className="line">
                      <span className="label">Work at:</span> {user.work_at}
                    </p>
                    <p className="line">
                      <span className="label">Years experience:</span>{" "}
                      {user.years_experience}{" "}
                      <span className="label">Years</span>{" "}
                    </p>
                    <p className="line">
                      <span className="label">Earning:</span> {user.earnings}{" "}
                      <span className="label">EGP</span>
                    </p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      )}
    </>
  );
};

export default TeamPage;
